import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import ComponentHeader from "../Header/ComponentHeader";
import KeyFigureNew from "../Elements/KeyFigureNew";
import { useInView } from "react-intersection-observer";
import {
  HeadingMunicipality,
  headingSmall,
  FiguresWrapper,
  heading48
} from "../../Util/StyleProps";
import { primaryColor, secondaryColor } from "../../Util/Colors";

import {
  calculatePercentage,
  isCurrentYear,
  periodToComma
} from "../../Helpers/CommonHelper";
import SvgLayout from "./../Layout/SvgLayout";
import EmptySpace from "../Elements/EmptySpace";

const LivingConditionContainer = props => {
  const { data, sweden, blockColor, scroll } = props;
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });

  let municipality1 = data[0];
  let municipality2 = data[1];

  let cohabitingPercentage = 0;
  let singlePercentage = 0;
  let otherPercentage = 0;

  if (sweden.livingcondition) {
    cohabitingPercentage = calculatePercentage(
      sweden.livingcondition.cohabiting,
      sweden.livingcondition.total
    );

    singlePercentage = calculatePercentage(
      sweden.livingcondition.single,
      sweden.livingcondition.total
    );

    otherPercentage = calculatePercentage(
      sweden.livingcondition.other,
      sweden.livingcondition.total
    );
  }
  let subText = ` I Sverige är ${periodToComma(
    cohabitingPercentage
  )} procent sammanboende (med eller utan barn). ${periodToComma(
    singlePercentage
  )} procent ensamstående 
  (med eller utan barn). ${periodToComma(
    otherPercentage
  )} procent tillhör någon annan typ av hushåll (${
    sweden.livingcondition ? sweden.livingcondition.year : ""
  }).`;

  // Accessibility
  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "är"
        : "var"
      : "";

    return municipality
      ? `I ${municipality.name} kommun ${str} ${calculatePercentage(
          municipality.cohabiting,
          municipality.total
        )} procent sammanboende (med eller utan barn) år ${
          municipality.year
        }. ${calculatePercentage(
          municipality.single,
          municipality.total
        )} procent ${str} ensamstående (med eller utan barn)
        och ${calculatePercentage(
          municipality.other,
          municipality.total
        )} procent tillhör någon annan typ av hushåll.`
      : "";
  };

  return (
    <BlockLayout background={blockColor}>
      <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
      <path d="M20.2783 51.423C18.8444 51.423 17.6158 50.9027 16.5925 49.8622C15.5691 48.8222 15.0575 47.5719 15.0575 46.1113C15.0575 44.6269 15.57 43.3708 16.595 42.343C17.6194 41.3152 18.8514 40.8013 20.2908 40.8013C21.7669 40.8013 23.0286 41.3186 24.0758 42.353C25.1236 43.3875 25.6475 44.6463 25.6475 46.1297C25.6475 47.6041 25.1225 48.855 24.0725 49.8822C23.0225 50.9094 21.7577 51.423 20.2783 51.423ZM59.635 51.423C58.1611 51.423 56.8983 50.9027 55.8466 49.8622C54.795 48.8222 54.2691 47.5719 54.2691 46.1113C54.2691 44.6269 54.7955 43.3708 55.8483 42.343C56.9016 41.3152 58.1675 40.8013 59.6458 40.8013C61.0697 40.8013 62.2944 41.3186 63.32 42.353C64.3461 43.3875 64.8591 44.6463 64.8591 46.1297C64.8591 47.6041 64.3475 48.855 63.3241 49.8822C62.3013 50.9094 61.0716 51.423 59.635 51.423ZM40.0641 48.0505C38.1452 48.0505 36.5052 47.3688 35.1441 46.0055C33.783 44.6416 33.1025 43.003 33.1025 41.0897C33.1025 39.1597 33.7844 37.5169 35.1483 36.1613C36.5116 34.8058 38.1502 34.128 40.0641 34.128C41.983 34.128 43.623 34.8058 44.9841 36.1613C46.3452 37.5169 47.0258 39.1541 47.0258 41.073C47.0258 42.9925 46.3452 44.6352 44.9841 46.0013C43.623 47.3675 41.983 48.0505 40.0641 48.0505ZM25.0258 68.2813C25.7819 64.8497 27.5472 61.9833 30.3216 59.6822C33.0955 57.3811 36.3402 56.2305 40.0558 56.2305C43.7714 56.2305 47.0125 57.3825 49.7791 59.6863C52.5452 61.9908 54.3091 64.8558 55.0708 68.2813H25.0258ZM8.3333 68.2813C8.3333 64.9052 9.50441 62.0527 11.8466 59.7238C14.1889 57.395 17.0072 56.2305 20.3016 56.2305C21.5211 56.2305 22.6772 56.3863 23.77 56.698C24.8627 57.0102 25.8797 57.4783 26.8208 58.1022C25.4486 59.4477 24.3052 60.9902 23.3908 62.7297C22.4764 64.4697 21.8302 66.3202 21.4525 68.2813H8.3333ZM58.6283 68.2813C58.2605 66.2986 57.6202 64.4397 56.7075 62.7047C55.7941 60.9691 54.6394 59.4244 53.2433 58.0705C54.1794 57.5016 55.1863 57.0527 56.2641 56.7238C57.3425 56.395 58.4702 56.2305 59.6475 56.2305C62.943 56.2305 65.77 57.395 68.1283 59.7238C70.4872 62.0527 71.6666 64.9052 71.6666 68.2813H58.6283ZM7.35913 37.7563L5.1283 34.8013L40.0641 8.33301L54.3975 19.2113V11.5322H61.615V24.6555L75 34.8013L72.7375 37.7563L40.0641 13.0955L7.35913 37.7563Z" fill="#1F44FF"/>
      <path d="M7.35913 37.7563L5.1283 34.8013L40.0641 8.33301L54.3975 19.2113V11.5322H61.615V24.6555L75 34.8013L72.7375 37.7563L40.0641 13.0955L7.35913 37.7563Z" fill="#0F0865"/>
      </svg>
      <ComponentHeader heading={"Så ser våra hushåll ut"} text={subText} />
      {municipality1 ? (
        <div ref={ref}>
          <FiguresWrapper maxWidth="900px">
            {municipality1 ? (
              <SvgLayout width="47%">
                <HeadingMunicipality
                  aria-label={ariaLabel(municipality1)}
                  marginBottom="24px"
                >
                  {municipality1.name}
                </HeadingMunicipality>

                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={0.75}
                  iconName={"person"}
                  alt="Ikon person"
                  size={heading48}
                  value={calculatePercentage(
                    municipality1.single,
                    municipality1.total
                  )}
                  subText={"ensamstående"}
                  unit={"%"}
                />
                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={0.75}
                  iconName={"people"}
                  alt="Ikon personer"
                  size={heading48}
                  value={calculatePercentage(
                    municipality1.cohabiting,
                    municipality1.total
                  )}
                  subText={"sammanboende"}
                  unit={"%"}
                />
                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={0.75}
                  iconName={"person-add"}
                  alt="Person lägg till"
                  size={heading48}
                  value={calculatePercentage(
                    municipality1.other,
                    municipality1.total
                  )}
                  marginBottom={"0px"}
                  subText={"övriga hushåll"}
                  unit={"%"}
                />
              </SvgLayout>
            ) : (
              <div></div>
            )}
            {municipality2 ? (
              <SvgLayout width="47%">
                <HeadingMunicipality
                  color={secondaryColor}
                  aria-label={ariaLabel(municipality2)}
                  marginBottom="24px"
                >
                  {municipality2.name}
                </HeadingMunicipality>

                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={1.75}
                  iconName={"person"}
                  alt="Ikon person"
                  color={secondaryColor}
                  size={heading48}
                  value={calculatePercentage(
                    municipality2.single,
                    municipality2.total
                  )}
                  subText={"ensamstående"}
                  unit={"%"}
                />
                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={1.75}
                  iconName={"people"}
                  alt="Ikon personer"
                  color={secondaryColor}
                  size={heading48}
                  value={calculatePercentage(
                    municipality2.cohabiting,
                    municipality2.total
                  )}
                  subText={"sammanboende"}
                  unit={"%"}
                />
                <KeyFigureNew
                  triggerAnimation={inView}
                  delay={1.75}
                  iconName={"person-add"}
                  alt="Person lägg till"
                  color={secondaryColor}
                  size={heading48}
                  value={calculatePercentage(
                    municipality2.other,
                    municipality2.total
                  )}
                  marginBottom={"0px"}
                  subText={"övriga hushåll"}
                  unit={"%"}
                />
              </SvgLayout>
            ) : (
              <SvgLayout width="50%">
                <EmptySpace scroll={scroll} />
              </SvgLayout>
            )}
          </FiguresWrapper>
        </div>
      ) : null}
    </BlockLayout>
  );
};

export default LivingConditionContainer;
